<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <app-form-control>
    <div class="flex">
      <p-password
        [fluid]="true"
        [formControl]="form.controls.password"
        appPrimengPassword
        autocomplete="off"
        class="mr-3 flex-1"
        placeholder="Wprowadź nowe hasło" />

      <p-button
        (onClick)="handleGeneratePasswordClick()"
        [text]="true"
        appPrimengButton
        label="Generuj hasło"
        type="button" />
    </div>
  </app-form-control>

  <p-button
    [disabled]="form.invalid"
    [fluid]="true"
    appPrimengButton
    label="Zatwierdź"
    size="large"
    type="submit" />
</form>
